import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import React from 'react';
import { Document } from '@contentful/rich-text-types';
import { clsx } from 'clsx';
import styles from './richtext.module.scss';

export type RichtextProps = {
  document: Document;
  textType?: 'responsive' | 'normal' | 'medium';
  className?: string;
};

export const Richtext: React.FC<RichtextProps> = ({
  document,
  textType = 'responsive',
  className
}) => (
  <div className={clsx([styles[textType], className])}>{documentToReactComponents(document)}</div>
);

export type RichtextElementType = typeof Richtext;
